import { Divider, Row, Upload } from "antd";
import { Image } from "react-bootstrap";
import styled from "styled-components";

export const SignImage = styled(Image)`
  width: 100%;
  margin-top: 1rem;
`;
